// simple counter starting at 0
import { useState } from 'react'

export default function useCounter(initialCounter = 0) {
  const [counter, setCounter] = useState(initialCounter)
  const resetCounter = () => {
    setCounter(0)
  }
  const incrementCounter = (increment = 1) => {
    setCounter(counter + increment)
  }
  return { counter, incrementCounter, resetCounter, setCounter }
}
